import type { MetricPolarity } from '../models/anomaly.types'
import { LOWER_IS_BETTER_FALLBACK } from '../models/polarity'

export type LowerIsBetterLookup = (metricField: string) => boolean | null | undefined

const fallback = new Set<string>(LOWER_IS_BETTER_FALLBACK)

/** Resolve catalog-first; the static legacy list is used only on a catalog miss. */
export function resolvePolarity(
  metricField: string,
  isLowerBetter?: LowerIsBetterLookup,
): MetricPolarity {
  const catalogValue = isLowerBetter?.(metricField)
  if (typeof catalogValue === 'boolean') {
    return catalogValue ? 'lower_is_better' : 'higher_is_better'
  }
  return fallback.has(metricField) ? 'lower_is_better' : 'higher_is_better'
}
